import SectionTitleSimple from './SectionTitleSimple';

export default SectionTitleSimple;
